module.exports = __webpack_public_path__ + "img/F5-4B.87237df4.png";